import { Component, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MATERIAL_IMPORTS } from '../../material/material';
import { AuthService } from '../../../core/auth/auth.service';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, RouterOutlet, ...MATERIAL_IMPORTS],
  templateUrl: './navbar.html',
  styleUrl: './navbar.scss'
})
export class Navbar {
  protected readonly auth = inject(AuthService);
  protected readonly opened = signal(true);

  toggle(): void {
    this.opened.update((v) => !v);
  }

  login(): void {
    void this.auth.login();
  }

  logout(): void {
    void this.auth.logout();
  }

  account(): void {
    this.auth.account();
  }
}
